// import React from "react";
// import {
//   FaLightbulb,
//   FaLaptopCode,
//   FaShieldAlt,
//   FaVial,
//   FaGlobe,
// } from "react-icons/fa";

// function DevelopmentApproach() {
//   const steps = [
//     {
//       step: 1,
//       title: "Ideation & Feasibility Analysis",
//       icon: <FaLightbulb size={35} />,
//     },
//     {
//       step: 2,
//       title: "Design & UX/UI Development",
//       icon: <FaLaptopCode size={35} />,
//     },
//     {
//       step: 3,
//       title: "Smart Contract & Platform Integration",
//       icon: <FaShieldAlt size={35} />,
//     },
//     {
//       step: 4,
//       title: "Extensive Testing & Quality Assurance",
//       icon: <FaVial size={35} />,
//     },
//     {
//       step: 5,
//       title: "Mainnet Deployment & Future Maintenance",
//       icon: <FaGlobe size={35} />,
//     },
//   ];

//   return (
//     <div className="services-area pt-5 pb-5">
//       <div className="container text-center">
//         <h2 className="title fw-bold mb-4">
//           How Our Development Approach Sets Us Apart
//         </h2>
//         <p
//           className="mt-2 mb-5 mx-auto"
//           style={{ maxWidth: "800px", color: "#555" }}
//         >
//           Achieve complete end-to-end realization flawlessly executing our
//           rigorous multistage deployment framework precisely generating
//           optimized and battle-tested transparent infrastructure globally
//           natively.
//         </p>

//         {/* Timeline Grid layout for simplicity & responsiveness */}
//         <div className="row gy-5 justify-content-center mt-4">
//           {steps.map((stage, i) => (
//             <div className="col-lg-2 col-md-4 position-relative" key={i}>
//               {/* Optional connector */}
//               {i < steps.length - 1 && (
//                 <div
//                   className="d-none d-lg-block position-absolute"
//                   style={{
//                     top: "35%",
//                     right: "-30%",
//                     width: "60%",
//                     height: "2px",
//                     background: "#cee2fa",
//                     zIndex: 0,
//                   }}
//                 ></div>
//               )}

//               <div
//                 className="icon-box mx-auto d-flex align-items-center justify-content-center bg-white text-primary position-relative z-1 mb-3"
//                 style={{
//                   width: "80px",
//                   height: "80px",
//                   borderRadius: "50%",
//                   border: "4px solid #cee2fa",
//                   boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
//                 }}
//               >
//                 {stage.icon}
//               </div>

//               <div
//                 className="bg-primary text-white mx-auto d-flex align-items-center justify-content-center mb-3 fw-bold"
//                 style={{
//                   width: "30px",
//                   height: "30px",
//                   borderRadius: "50%",
//                   fontSize: "14px",
//                 }}
//               >
//                 {stage.step}
//               </div>

//               <h6
//                 className="fw-bold"
//                 style={{ fontSize: "15px", lineHeight: "1.4" }}
//               >
//                 {stage.title}
//               </h6>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default DevelopmentApproach;

import React from "react";
// import "./DevelopmentApproach.css";
import {
  FaLightbulb,
  FaLaptopCode,
  FaShieldAlt,
  FaVial,
  FaGlobe,
} from "react-icons/fa";

function DevelopmentApproach() {
  const steps = [
    {
      step: 1,
      title: "Ideation & Feasibility Analysis",
      icon: <FaLightbulb />,
    },
    {
      step: 2,
      title: "Design & UX/UI Development",
      icon: <FaLaptopCode />,
    },
    {
      step: 3,
      title: "Smart Contract & Platform Integration",
      icon: <FaShieldAlt />,
    },
    {
      step: 4,
      title: "Extensive Testing & Quality Assurance",
      icon: <FaVial />,
    },
    {
      step: 5,
      title: "Mainnet Deployment & Future Maintenance",
      icon: <FaGlobe />,
    },
  ];

  return (
    <section className="dev-section">
      <div className="container text-center">
        {/* HEADER */}
        <h2 className="dev-title">
          How Our Development Approach Sets Us Apart
        </h2>

        <p className="dev-desc">
          Achieve complete end-to-end realization with our optimized,
          battle-tested deployment framework built for global scalability.
        </p>

        {/* STEPS */}
        <div className="dev-steps">
          {steps.map((item, i) => (
            <div className="dev-step" key={i}>
              {/* Line Connector */}
              {i !== steps.length - 1 && <div className="dev-line"></div>}

              {/* ICON */}
              <div className="dev-icon">{item.icon}</div>

              {/* STEP NUMBER */}
              <div className="dev-number">{item.step}</div>

              {/* TITLE */}
              <h6 className="dev-step-title">{item.title}</h6>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DevelopmentApproach;
